import { render, staticRenderFns } from "./MyPage2.vue?vue&type=template&id=592e4aaa&scoped=true"
import script from "./MyPage2.vue?vue&type=script&lang=js"
export * from "./MyPage2.vue?vue&type=script&lang=js"
import style0 from "./MyPage2.vue?vue&type=style&index=0&id=592e4aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e4aaa",
  null
  
)

export default component.exports